import { useLayoutEffect, useState } from 'react'

const useCheckMobileScreen = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024)
  const handleWindowSizeChange = () => {
    if (window.innerWidth <= 1024) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  // we check against 1024 as that's the largest possible width on iPad / mobile
  return isMobile
}

export default useCheckMobileScreen
